import React from 'react';
import PropTypes from 'prop-types';

const Calendar = (props) => {
  const { onChangePage } = props;

  return (
    <React.Fragment>
      <p>Calendar</p>
      <div className='row'>
        <div className='col cal-box'>
          
        </div>
        <div className='col cal-box'>
          
        </div>
        <div className='col cal-box'>
          1
        </div>
        <div className='col cal-box'>
          2
        </div>
        <div className='col cal-box'>
          3
        </div>
        <div className='col cal-box'>
          4
        </div>
        <div className='col cal-box'>
          5
        </div>
      </div>
      <div className='row'>
        <div className='col cal-box'>
          6
        </div>
        <div className='col cal-box'>
          7
        </div>
        <div className='col cal-box'>
          8
        </div>
        <div className='col cal-box'>
          9
        </div>
        <div className='col cal-box'>
          10
        </div>
        <div className='col cal-box'>
          11
        </div>
        <div className='col cal-box'>
          12
        </div>
      </div>
      <div className='row'>
        <div className='col cal-box'>
          13
        </div>
        <div className='col cal-box'>
          14
        </div>
        <div className='col cal-box'>
          15
        </div>
        <div className='col cal-box'>
          16
        </div>
        <div className='col cal-box'>
          17
        </div>
        <div className='col cal-box'>
          18
        </div>
        <div className='col cal-box'>
          19
        </div>
      </div>
      <div className='row'>
        <div className='col cal-box'>
          20
        </div>
        <div className='col cal-box'>
          21
        </div>
        <div className='col cal-box'>
          22
        </div>
        <div className='col cal-box'>
          23
        </div>
        <div className='col cal-box'>
          24
        </div>
        <div className='col cal-box'>
          25
        </div>
        <div className='col cal-box'>
          26
        </div>
      </div>
      <div className='row'>
        <div className='col cal-box'>
          27
        </div>
        <div className='col cal-box'>
          28
        </div>
        <div className='col cal-box'>
          29
        </div>
        <div className='col cal-box'>
          30
        </div>
        <div className='col cal-box'>
          31
        </div>
        <div className='col cal-box'>
          
        </div>
        <div className='col cal-box'>
          
        </div>
      </div>
      <button className='btn btn-info' onClick = { () => onChangePage('MainMenu') }>Main Menu</button>
      <button className='btn btn-info' onClick = { () => onChangePage('Event') }>Add Event</button>
    </React.Fragment>
  )
}

Calendar.propType = {
  onChangePage: PropTypes.func
}

export default Calendar;